import React from 'react';
import { Button, Badge } from 'reactstrap';
import DataTable from '../../../../components/Common/DataTable';
import { formatDateTime } from '../../../../utils/date';

const getActionBadgeProps = (action) => {
    switch (action) {
        case 'CREATE': return { theme: 'soft', color: 'success', icon: 'mdi mdi-plus-circle' };
        case 'UPDATE': return { theme: 'soft', color: 'primary', icon: 'mdi mdi-pencil' };
        case 'DELETE': return { theme: 'soft', color: 'danger', icon: 'mdi mdi-delete' };
        default: return { theme: 'soft', color: 'secondary', icon: 'mdi mdi-information' };
    }
};

const AuditList = ({ logs, loading, hasMore, onLoadMore, onViewDetails }) => {

    const columns = [
        {
            key: 'createdAt',
            label: 'Data/Hora',
            render: (row) => row.createdAt ? formatDateTime(row.createdAt) : '-'
        },
        {
            key: 'userName',
            label: 'Usuário',
            className: 'fw-medium'
        },
        {
            key: 'module',
            label: 'Módulo'
        },
        {
            key: 'action',
            label: 'Ação',
            render: (row) => {
                const props = getActionBadgeProps(row.action);
                return (
                    <Badge color={props.color} className="font-size-11 text-white">
                        <i className={`${props.icon} me-1`}></i>
                        {row.action}
                    </Badge>
                );
            }
        },
        {
            key: 'description',
            label: 'Descrição'
        },
        {
            key: 'details',
            label: 'Ações',
            render: (row) => (
                <Button 
                    color="light" 
                    size="sm" 
                    // Só mostra botão "Ver Detalhes" se o log tiver a chave details diferente de nulo
                    disabled={!row.details}
                    onClick={() => onViewDetails(row)}
                >
                    <i className="mdi mdi-eye me-1"></i> Detalhes
                </Button>
            )
        }
    ];

    return (
        <React.Fragment>
            <div className="w-100">
                        <DataTable
                            data={logs}
                            columns={columns}
                            keyField="id"
                            noCard={true}
                            isLoading={loading && logs.length === 0}
                            emptyMessage="Nenhum registro de auditoria encontrado."
                            emptySubMessage="Não há logs correspondentes aos filtros atuais."
                        />

                        {/* Botão Carregar Mais se houver mais registros na base e já tiver carregado algo */}
                        {hasMore && logs.length > 0 && (
                            <div className="text-center p-3 border-top bg-light">
                                <Button 
                                    color="primary" 
                                    outline
                                    onClick={onLoadMore}
                                    disabled={loading}
                                >
                                    {loading ? (
                                        <><i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i> Carregando...</>
                                    ) : (
                                        'Buscar Registros Antigos'
                                    )}
                                </Button>
                            </div>
                        )}
            </div>
        </React.Fragment>
    );
};

export default AuditList;
